module.exports = __webpack_public_path__ + "static/media/logo.770b94e1.jpeg";